package com.trevorwiebe.timesheet.admin.reporting.presentation

enum class ReportType(val label: String) {
    IFTA("IFTA"),
    GENERAL_MILEAGE("General Mileage"),
    MISSING_START_END("Missing Start/End"),
    REVENUE_PER_MILE("Revenue / Mile"),
    LOADS_WITHOUT_TRUCK("Loads Without Truck");

    /** Reports built from loads rather than just the mileage log. */
    val usesLoads: Boolean get() = this == REVENUE_PER_MILE || this == LOADS_WITHOUT_TRUCK
}
